// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.controls {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 0.5rem 1rem;
  margin-bottom: 1rem;
}

.grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(200px, 1fr));
  grid-gap: 1rem;
  margin-bottom: 1.5rem;
}

.card {
  font-size: 11px;
  font-family: monospace;
}

.chart {
  border: 1px solid #d5d9e0;
}
`, "",{"version":3,"sources":["webpack://./src/examples/xy-components/plotline/plotline-label-bleed/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".controls {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-gap: 0.5rem 1rem;\n  margin-bottom: 1rem;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(200px, 1fr));\n  grid-gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.card {\n  font-size: 11px;\n  font-family: monospace;\n}\n\n.chart {\n  border: 1px solid #d5d9e0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"controls": `controls`,
	"grid": `grid`,
	"card": `card`,
	"chart": `chart`
};
export default ___CSS_LOADER_EXPORT___;
